import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class AdminHomeComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
